import { render, staticRenderFns } from "./TheFormFooter.vue?vue&type=template&id=4f3340cd&scoped=true&"
import script from "./TheFormFooter.vue?vue&type=script&lang=js&"
export * from "./TheFormFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheFormFooter.vue?vue&type=style&index=0&id=4f3340cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3340cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
